import { DocChargeDataEntity } from "domain/entity/DocumentPreview/DocChargeDataEntity"

export interface DocChargeDataCriteria {
    docChargeDatas: DocChargeDataEntity[],
    docHdrId: number,
    approveReject: string,
    approveRejactReasonCode: string,
    draftInvoiceNo: string,
    consortiumCode: string,
    vesselCode: string,
    voyageCode: string,
    etd: Date | null,
    billToCompany: string,


    [key: string]: string[] | string | Date | boolean | number | number[] | null | Object | undefined
}

export const EMPTY_DOC_CHARGE_DATA_CRITERIA: DocChargeDataCriteria = {
    docChargeDatas: [],
    docHdrId: 0,
    approveReject: "",
    approveRejactReasonCode: "",
    draftInvoiceNo: "",
    consortiumCode: "",
    vesselCode: "",
    voyageCode: "",
    etd: null,
    billToCompany: ""
}